import { gql } from '@apollo/client';

const MUTATION = gql`
  mutation DeleteTsSupportAdminRole($orgId: ID) {
    deleteTsSupportAdminRole(organizationId: $orgId)
  }
`;

export default MUTATION;
